import React from 'react'
import axios from 'axios'
import ButtonDialog from '../shared/ButtonDialog'
import { DialogActions, DialogContentText } from '@mui/material'
import { DeleteProps } from '../shared/DeleteProps'
import Button from '@mui/material/Button'
import DeleteIcon from '@mui/icons-material/Delete'
import SimulationIcon from '@mui/icons-material/AutoGraph'
import { useAuth } from '../../context/useAuth'

export default function DeleteSimulation({ disabled, value, setData }: DeleteProps) {
  const [open, setOpen] = React.useState(false)
  const { csrf } = useAuth()

  return (
    <ButtonDialog
      disabled={disabled}
      title='Delete Simulation'
      icon={<SimulationIcon />}
      iconButton={<DeleteIcon />}
      content={
        <DialogContentText>{`Are you sure you want to delete Simulation: ${value.simulation_name}?`}</DialogContentText>
      }
      actions={
        <DialogActions>
          <Button
            color='error'
            variant='contained'
            size='small'
            onClick={async () => {
              try {
                const res = await axios.delete(`${process.env.REACT_APP_API}/${value.simulation_name}`, {
                  withCredentials: true,
                  headers: {
                    'X-CSRFToken': csrf,
                  },
                })
                setData(res.data)
                setOpen(false)
              } catch (err) {
                console.log('err:', err)
              }
            }}
          >
            Delete
          </Button>
        </DialogActions>
      }
      open={open}
      setOpen={setOpen}
    />
  )
}
